import { disableKosten } from '../../../helpers/showKosten';
import { getCustomFormComponent } from '../custom/form_component';
import { getCustomFormConfigVsme } from '../custom/form_config_vsme';
import { getCustomFormEventHandler } from '../custom/form_event_handler';
import { getCustomFormConfigEED } from '../custom/getCustomFormConfigEED';
import { getWZobject } from '../../../main/functions/getGewerk';
import { IDs } from '../../../helpers/IDs';
import { StructureService } from '../../../services/structure_service';
import { hasFeature } from '../../../control/hasFeature';
import { Features } from '../../../control/features';

// ************ ACHTUNG, NICHT NUR FÜR CO2 ******************

export function getCustomFormConfig(entity: string, item: any, data: any, contextKey?: string, filter?: any): any {
    let config: any = {};
    const hasItem: boolean = item;
    data = data || {};
    item = item || {};

    const konfiguration: any = (data[IDs.ENT_KONFIGURATION] || [])[0] || {};
    const bereich_key: string = ((data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
    const co2_fussabdruck_ghg = konfiguration.co2_fussabdruck_modus === 'ghg';
    const components: any = getCustomFormComponent(entity, item, data) || {};
    const dateneingabeVariante = konfiguration.dateneingabe_variante || null;
    const events: any = getCustomFormEventHandler(entity, item, data) || {};
    const isGefuehrterModus: boolean = konfiguration.gefuehrter_modus_orig === 1; // {1} Ja
    const modul: string = data.MODUL_SELECTED || null;

    if (isGefuehrterModus && dateneingabeVariante === 'vsme') {
        config = getCustomFormConfigVsme(entity, item, data, contextKey, filter) || {};
    }

    config = getCustomFormConfigVorsteuer(entity, item, data, config);
    config = getCustomFormConfigNutzerEinheit(entity, item, config);

    // if (true || modul === 'eed') {
    //     config = getCustomFormConfigEED(entity, item, data, contextKey, filter) || {};
    // }

    switch (entity) {
        case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
        case IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL:
            //  console.log('ITEM: ', item);
            if (modul === 'cfm') {
                if (['supplier_specific', 'user_specific'].indexOf(item.modus) === -1) {
                    config.name = { hidden_input: true };
                    config.datenqualitaet_emissionsfaktor = { hidden_input: true };
                }
            } else {
                config.datenherkunft = { hidden: true };
                config.datenqualitaet_emissionsfaktor = { hidden: true };
                config.bewertung_emissionsfaktor = { hidden: true };
            }
            if (!co2_fussabdruck_ghg) {
                if (entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF) {
                    config.modus = { hidden: true };
                    config.einheit = { hidden: true };
                    config.faktor = { hidden: true };
                    // config.kategorie_tid = { hidden: true };
                    config.quelle = { hidden: true };
                    config.name = { hidden: true };
                    config.menge = { required: true };
                    config.art_tid = { required: true };
                } else if (entity === IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL) {
                    config.modus = { hidden: true };
                    config.kategorie_tid = { hidden: true };
                    config.art_tid = { hidden: true };
                    config.menge = { required: true };
                    config.faktor = { required: true };
                }
            } else {
                if (!hasItem) {
                    //  config.name = { hidden_input: true };
                    config.einheit = { hidden_input: true };
                    config.faktor = { hidden_input: true };
                    config.quelle = { hidden_input: true };
                } else if (!item.modus || +item.modus === 0) {
                    config.einheit = { hidden_input: true };
                    config.faktor = { hidden_input: true };
                    config.quelle = { hidden_input: true };
                    // config.name = { hidden_input: true };
                    config.menge = { required: true };
                    config.art_tid = { required: true };
                } else if (item.modus === 'average_data') {
                    config.faktor = { hidden_input: true, required: false };
                    config.quelle = { hidden_input: true };
                    config.name = { hidden_input: true };
                    config.menge = { required: true };
                    config.art_tid = { required: true };
                } else if (item.modus === 'spend_based') {
                    config.einheit = { hidden_input: true };
                    config.faktor = { hidden_input: true, required: false };
                    config.quelle = { hidden_input: true };
                    config.name = { hidden_input: true };
                    config.menge = { required: true };
                    config.art_tid = { required: true };
                } else {
                    config.menge = { required: true };
                    config.faktor = { required: true };
                    config.art_tid = { required: !item.name };
                }
                // WKETOOL-103: Scope 9.2 > Kategorie: Kunstobjekt > Art sollte kein Pflichtfeld sein, da hier keine Einträge stehen
                if (entity === IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL) {
                    if (item.kategorie_tid_orig === 2) { // Kunstobjekte
                        config.art_tid = { required: false };
                    }
                }
                if (entity === IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL) {
                    if (item.art_tid === 'Photovoltaikanlage') {
                        [
                            'name', 'modus', 'einheit', 'menge', 'faktor', 'quelle', 'datenherkunft', 'datenherkunft',
                            'datenqualitaet_emissionsfaktor', 'bewertung_emissionsfaktor', 'anhang', 'bemerkung'
                        ].forEach((key: string) => config[key] = {
                            ...((config[key] || {}).hidden ? config[key] : { readonly: true })
                        });
                    }
                }
            }
            break;
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
            config.entfernung = { label: 'Transportstrecke [km]' };
            if (!co2_fussabdruck_ghg) {
                config.kosten = { hidden: true };
                config.energietraeger_tid = { hidden: true };
                config.verbrauch = { hidden: true };
                config.modus = { hidden: true };
                config.hin_rueck = { hidden: true };
                config.art = { hidden: true };
                config.transportmittel_mobilitaet = { hidden: true };
                config.kraftstoff_distance = { hidden: true };
                config.uebernachtungen = { hidden: true };
                config.reiseland = { hidden: true };
                config.uebernachtungen_anzahl = { hidden: true };
                config.teilnehmer = { hidden: true };
                config.unterkunft = { hidden: true };
                config.personen = { hidden: true };
                config.hin_rueck = { hidden: true };

                if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                    config.entfernung = { ...config.entfernung, readonly: true };
                } else {
                    config.transportmittel = { required: true };
                }
            } else if (!item || !item.art || item.art === 0 || item.art === '0' || item.art === 'gueter') {
                config.personen = { hidden_input: true };
                config.hin_rueck = { hidden_input: true };
                if (bereich_key === 'handwerk' || false) {
                    config.art = { hidden: true };
                    config.transportmittel_mobilitaet = { hidden: true };
                    config.kraftstoff_distance = { hidden: true };
                    config.uebernachtungen = { hidden: true };
                    config.reiseland = { hidden: true };
                    config.uebernachtungen_anzahl = { hidden: true };
                    config.teilnehmer = { hidden: true };
                    config.unterkunft = { hidden: true };
                } else {
                    config.transportmittel_mobilitaet = { hidden_input: true };
                    config.kraftstoff_distance = { hidden_input: true };
                    config.uebernachtungen = { hidden_input: true };
                    config.reiseland = { hidden_input: true };
                    config.uebernachtungen_anzahl = { hidden_input: true };
                    config.teilnehmer = { hidden_input: true };
                    config.unterkunft = { hidden_input: true };
                }
                if (!item || !item.modus || item.modus === 0 || item.modus === '0' || item.modus === 'distance_based') {
                    config.kosten = { hidden_input: true };
                    config.energietraeger_tid = { hidden_input: true };
                    config.verbrauch = { hidden_input: true };
                    if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                        config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                        config.entfernung = { ...config.entfernung, readonly: true };
                    } else {
                        config.transportmittel = { required: true };
                        config.entfernung = { ...config.entfernung, required: true };
                    }
                    config.menge = { required: true };
                } else if (item.modus === 'spend_based') {
                    config.energietraeger_tid = { hidden_input: true };
                    config.verbrauch = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, hidden_input: true };
                    // config.teilstrecken = { hidden_input: true };
                    config.menge = { hidden_input: true };
                    if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                        config.kosten = { readonly: true };
                        config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                    } else {
                        config.kosten = { required: true };
                        config.transportmittel = { required: true };
                    }
                } else if (item.modus === 'fuel_based') {
                    config.kosten = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, hidden_input: true };
                    config.menge = { hidden_input: true };
                    // config.teilstrecken = { hidden_input: true };
                    config.transportmittel = { hidden_input: true };
                    if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                        config.verbrauch = { readonly: true, hidden_msg: 'Mehrere Verbräuche' };
                        config.energietraeger_tid = { hidden_input: true, hidden_msg: 'Mehrere Energieträger' };
                    } else {
                        config.verbrauch = { required: true };
                        config.energietraeger_tid = { required: true };
                    }
                } else if (item.modus === 'user_specific') {
                    [
                        'teilstrecken', 'hin_rueck', 'transportmittel', 'transportmittel_mobilitaet', 'kraftstoff_distance', 'personen',
                        'entfernung', 'menge', 'kosten', 'energietraeger_tid', 'verbrauch', 'uebernachtungen', 'reiseland',
                        'uebernachtungen_anzahl', 'teilnehmer', 'unterkunft'
                    ].forEach((key: string) => config[key] = {
                        ...((config[key] || {}).hidden ? config[key] : { hidden_input: true })
                    });
                }
            } else if (item.art === 'mobilitaet') { // Ab hier Mobilität
                config.transportmittel = { hidden_input: true };
                config.menge = { hidden_input: true };
                delete config.entfernung.label;
                if (!item.modus || item.modus === 0 || item.modus === '0' || item.modus === 'distance_based') {
                    config.kosten = { hidden_input: true };
                    config.energietraeger_tid = { hidden_input: true };
                    config.verbrauch = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, required: true };
                    config.hin_rueck = { required: true };
                    if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                        config.transportmittel_mobilitaet = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                        config.entfernung = { ...config.entfernung, readonly: true };
                        config.kraftstoff_distance = { hidden_input: true };
                        config.personen = { required: true };
                    } else {
                        config.transportmittel_mobilitaet = { required: true };
                        config.entfernung = { ...config.entfernung, required: true };
                        if (item.transportmittel_mobilitaet === 'bus' || item.transportmittel_mobilitaet === 'reisebus' ||
                            item.transportmittel_mobilitaet === 'bahn' || item.transportmittel_mobilitaet === 'bahn_fern' ||
                            item.transportmittel_mobilitaet === 'tram' || item.transportmittel_mobilitaet === 'flugzeug_international' ||
                            item.transportmittel_mobilitaet === 'flugzeug_national') {
                            config.personen = { required: true };
                        } else {
                            config.personen = { hidden_input: true };
                        }
                    }
                } else if (item.modus === 'spend_based') {
                    config.energietraeger_tid = { hidden_input: true };
                    config.verbrauch = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, hidden_input: true };
                    config.hin_rueck = { hidden_input: true };
                    config.personen = { hidden_input: true };
                    config.kraftstoff_distance = { hidden_input: true };
                    if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                        config.kosten = { readonly: true };
                        config.transportmittel_mobilitaet = { hidden_input: true, hidden_msg: 'Mehrere Fahrzeuge' };
                    } else {
                        config.transportmittel_mobilitaet = { required: true };
                        config.kosten = { required: true };
                    }
                } else if (item.modus === 'fuel_based') {
                    config.kosten = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, hidden_input: true };
                    config.hin_rueck = { hidden_input: true };
                    config.transportmittel_mobilitaet = { hidden_input: true };
                    config.kraftstoff_distance = { hidden_input: true };
                    config.verbrauch = { required: true };
                    config.personen = { hidden_input: true };
                    if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                        config.verbrauch = { readonly: true, hidden_msg: 'Mehrere Verbräuche' };
                        config.energietraeger_tid = { hidden_input: true, hidden_msg: 'Mehrere Energieträger' };
                    } else {
                        config.verbrauch = { required: true };
                        config.energietraeger_tid = { required: true };
                    }
                } else if (item.modus === 'user_specific') {
                    [
                        'teilstrecken', 'hin_rueck', 'transportmittel', 'transportmittel_mobilitaet', 'kraftstoff_distance', 'personen',
                        'entfernung', 'menge', 'kosten', 'energietraeger_tid', 'verbrauch', 'uebernachtungen', 'reiseland',
                        'uebernachtungen_anzahl', 'teilnehmer', 'unterkunft'
                    ].forEach((key: string) => config[key] = {
                        ...((config[key] || {}).hidden ? config[key] : { hidden_input: true })
                    });
                }
                const transportmittel_mobilitaet: string = item.transportmittel_mobilitaet || '';
                if (!transportmittel_mobilitaet.startsWith('pkw_') || item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.kraftstoff_distance = { hidden_input: true };
                } else {
                    config.kraftstoff_distance = { required: true };
                }
                if ([0, 2].indexOf(+item.uebernachtungen_orig || +item.uebernachtungen || 0) !== -1 || item.uebernachtungen === 'Nein') {
                    config.uebernachtungen_anzahl = { hidden_input: true };
                    config.teilnehmer = { hidden_input: true };
                    config.reiseland = { hidden_input: true };
                    if (co2_fussabdruck_ghg) {
                        config.unterkunft = { hidden_input: true };
                    }
                } else {
                    config.reiseland = { required: true };
                    if (co2_fussabdruck_ghg) {
                        config.unterkunft = item.reiseland === 'deutschland'
                            ? { required: true }
                            : { hidden_input: true };
                    }
                }
                if (transportmittel_mobilitaet === 'uebernachtung') {
                    config.teilstrecken = { hidden_input: true };
                    config.hin_rueck = { hidden_input: true, required: false };
                    config.entfernung = { hidden_input: true, required: false };
                    config.uebernachtungen = { readonly: true };
                }
            }
            if (modul !== 'cfm' || !co2_fussabdruck_ghg) {
                config.name_nutzer = { hidden: true };
                config.einheit_nutzer = { hidden: true };
                config.menge_nutzer = { hidden: true };
                config.faktor_nutzer = { hidden: true };
                config.quelle_nutzer = { hidden: true };
                config.datenqualitaet_emissionsfaktor = { hidden: true };
                config.bewertung_emissionsfaktor = { hidden: true };
                config.datenherkunft = { hidden: !(modul === 'cfm') };
            } else if (item.modus !== 'user_specific') {
                config.name_nutzer = { hidden_input: true };
                config.einheit_nutzer = { hidden_input: true };
                config.menge_nutzer = { hidden_input: true };
                config.faktor_nutzer = { hidden_input: true };
                config.quelle_nutzer = { hidden_input: true };
                config.datenqualitaet_emissionsfaktor = { hidden_input: true };
            }
            // console.log('Config 3.4:', config);
            break;
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
            config.entfernung = { label: 'Transportstrecke [km]' };
            if (!co2_fussabdruck_ghg) {
                config.kosten = { hidden: true };
                config.energietraeger_tid = { hidden: true };
                config.verbrauch = { hidden: true };
                config.modus = { hidden: true };
                config.unterkunft = { hidden: true };
                config.uebernachtungen = { hidden: true };
                config.uebernachtungen_anzahl = { hidden: true };
                config.personen = { hidden: true };
                config.kraftstoff = { hidden: true };
                config.hin_rueck = { hidden: true };
                config.art = { hidden: true };
                config.menge = { required: true };

                if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                    config.entfernung = { ...config.entfernung, readonly: true };
                } else {
                    config.transportmittel = { required: true };
                }
            } else {
                config.art = { required: true };
                // ART Güter oder Mobilität
                if (item.art === 'gueter') {
                    config.modus = { required: true };
                    config.unterkunft = { hidden_input: true };
                    config.uebernachtungen = { hidden_input: true };
                    config.uebernachtungen_anzahl = { hidden_input: true };
                    config.personen = { hidden_input: true };
                    config.hin_rueck = { hidden_input: true };
                    config.menge = { required: true };
                } else if (item.art === 'mobilitaet') {
                    config.lieferant_tid = { hidden_input: true };
                    config.personen = { required: true };
                    config.menge = { hidden_input: true, required: false };
                    config.hin_rueck = { required: true };
                    config.uebernachtungen = { required: true };
                    delete config.entfernung.label;
                    if (
                        (+item.uebernachtungen_orig || 0) === 0 || (+item.uebernachtungen_orig || 0) === 2
                        || item.uebernachtungen === 'Nein' || +item.uebernachtungen === 2
                    ) {
                        config.uebernachtungen_anzahl = { hidden_input: true };
                        config.unterkunft = { hidden_input: true };
                    } else {
                        config.unterkunft = { required: true };
                        config.uebernachtungen_anzahl = { required: true };
                    }
                    if (item.transportmittel === 'uebernachtung') {
                        config.teilstrecken = { hidden_input: true };
                        config.hin_rueck = { hidden_input: true, required: false };
                        config.entfernung = { hidden_input: true, required: false };
                        config.uebernachtungen = { readonly: true };
                    }
                }
                if (!item.modus || item.modus === 0 || item.modus === '0' || item.modus === 'distance_based') {
                    config.kosten = { hidden_input: true };
                    config.energietraeger_tid = { hidden_input: true };
                    config.verbrauch = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, required: true };

                    if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                        config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                        config.entfernung = { ...config.entfernung, readonly: true };
                    } else {
                        config.entfernung = { ...config.entfernung, required: true };
                        config.transportmittel = { required: true };
                    }
                } else if (item.modus === 'spend_based') {
                    config.energietraeger_tid = { hidden_input: true };
                    config.verbrauch = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, hidden_input: true };
                    // config.teilstrecken = { hidden_input: true };
                    config.hin_rueck = { hidden_input: true };
                    config.menge = { hidden_input: true, required: false };
                    if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                        config.kosten = { readonly: true };
                        config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                    } else {
                        config.kosten = { required: true };
                        config.transportmittel = { required: true };
                    }
                } else if (item.modus === 'fuel_based') {
                    config.kosten = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, hidden_input: true };
                    config.menge = { hidden_input: true, required: false };
                    config.hin_rueck = { hidden_input: true };
                    // config.teilstrecken = { hidden_input: true };
                    config.transportmittel = { hidden_input: true };
                    config.personen = { hidden_input: true };
                    if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                        config.verbrauch = { readonly: true, hidden_msg: 'Mehrere Verbräuche' };
                        config.energietraeger_tid = { hidden_input: true, hidden_msg: 'Mehrere Energieträger' };
                    } else {
                        config.verbrauch = { required: true };
                        config.energietraeger_tid = { required: true };
                    }
                } else if (item.modus === 'user_specific') {
                    [
                        'teilstrecken', 'hin_rueck', 'transportmittel', 'personen', 'entfernung', 'menge', 'kosten', 'energietraeger_tid',
                        'verbrauch', 'uebernachtungen', 'uebernachtungen_anzahl', 'unterkunft'
                    ].forEach((key: string) => config[key] = {
                        ...((config[key] || {}).hidden ? config[key] : { hidden_input: true })
                    });
                }
            }
            if (modul !== 'cfm' || !co2_fussabdruck_ghg) {
                config.name_nutzer = { hidden: true };
                config.einheit_nutzer = { hidden: true };
                config.menge_nutzer = { hidden: true };
                config.faktor_nutzer = { hidden: true };
                config.quelle_nutzer = { hidden: true };
                config.datenqualitaet_emissionsfaktor = { hidden: true };
                config.bewertung_emissionsfaktor = { hidden: true };
                config.datenherkunft = { hidden: !(modul === 'cfm') };
            } else if (item.modus !== 'user_specific') {
                config.name_nutzer = { hidden_input: true };
                config.einheit_nutzer = { hidden_input: true };
                config.menge_nutzer = { hidden_input: true };
                config.faktor_nutzer = { hidden_input: true };
                config.quelle_nutzer = { hidden_input: true };
                config.datenqualitaet_emissionsfaktor = { hidden_input: true };
            }
            break;
        case IDs.ENT_CO2_SCOPE3_ABFALL:
            // console.log('S5', item.modus, item);
            if (modul !== 'cfm') {
                config.datenherkunft = { hidden: true };
                config.datenqualitaet_emissionsfaktor = { hidden: true };
                config.bewertung_emissionsfaktor = { hidden: true };
            }
            if (['weitere', 'gemischt', 'daemmmaterial', 'mineralisch'].indexOf(item.kategorie) !== -1) {
                config.unterkategorie = { hidden_input: true };
                config.verfahren = { hidden_input: true };
            }
            if (item.kategorie !== 'weitere') {
                config.freie_eingabe = { hidden_input: true };
            }
            if (!co2_fussabdruck_ghg) {
                config.modus = { hidden: true };
                config.co2_absolut = { hidden: true };
                if (item.kategorie === 'gemischt') {
                    config.menge = { hidden_input: true };
                    config.leerungen = { required: true };
                    config.volumen_tonne = { required: true };
                } else {
                    config.leerungen = { hidden_input: true };
                    config.volumen_tonne = { hidden_input: true };
                    config.menge = { required: true };
                }
            } else {
                if (item.modus !== 'user_specific') {
                    config.name_nutzer = { hidden_input: true };
                    config.einheit_nutzer = { hidden_input: true };
                    config.menge_nutzer = { hidden_input: true };
                    config.faktor_nutzer = { hidden_input: true };
                    config.quelle_nutzer = { hidden_input: true };
                }
                if (item.modus === 'waste_specific') {
                    config.co2_absolut = { hidden_input: true };
                    if (modul === 'cfm') {
                        config.datenqualitaet_emissionsfaktor = { hidden_input: true };
                    }
                    if (item.kategorie === 'gemischt') {
                        config.menge = { hidden_input: true };
                        config.leerungen = { required: true };
                        config.volumen_tonne = { required: true };
                    } else {
                        config.menge = { required: true };
                        config.leerungen = { hidden_input: true };
                        config.volumen_tonne = { hidden_input: true };
                    }
                } else if (item.modus === 'supplier_specific') {
                    config.co2_absolut = { required: true };
                    config.menge = { hidden_input: true };
                    config.leerungen = { hidden_input: true };
                    config.volumen_tonne = { hidden_input: true };
                } else {
                    config.co2_absolut = { hidden_input: true };
                    config.menge = { hidden_input: true };
                    config.leerungen = { hidden_input: true };
                    config.volumen_tonne = { hidden_input: true };
                }
            }
            // console.log('S5', item.modus, item, config, modul);
            break;
        case IDs.ENT_CO2_SCOPE3_REISEN:
            if (hasFeature(Features.CO2_SCOPE3_REISEN_TITEL, bereich_key)) {
                config.titel = { hidden: true, hidden_input: true };
            }

            const transportmittel: string = item.transportmittel || '';
            config.entfernung = { label: 'Entfernung [km]' };
            if (!transportmittel.startsWith('pkw_') || item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                config.kraftstoff = { hidden_input: true };
            } else {
                config.kraftstoff = { required: true };
            }

            if (!co2_fussabdruck_ghg) {
                config.modus = { hidden: true };
                config.kosten = { hidden: true };
                config.personen = { hidden: true };
                config.energietraeger_tid = { hidden: true };
                config.verbrauch = { hidden: true };
                config.entfernung = { ...config.entfernung, required: true };
                config.unterkunft = { hidden: true };
                config.hin_rueck = { hidden: true };
                if (item.firmenfahrzeug_orig === 1 || item.firmenfahrzeug === 'Ja' || item.firmenfahrzeug === 1) {
                    config.teilstrecken = { hidden_input: true };
                    config.transportmittel = { hidden_input: true };
                    config.kraftstoff = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, hidden_input: true, required: false };
                } else if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                    config.kraftstoff = { hidden_input: true };
                    config.entfernung = { ...config.entfernung, readonly: true };
                } else {
                    config.transportmittel = { required: true };
                    config.entfernung = { ...config.entfernung, required: true };
                }
                // WKETOOL-65: 346 "(Distance-based)" im  bei der "kompakten Erfassung" nicht anzeigen
                config.kraftstoff = {
                    ...(config.kraftstoff || {}),
                    label: 'Kraftstoff'
                };
            } else if (isJa('firmenfahrzeug', item)) {
                config.teilstrecken = { hidden_input: true };
                config.transportmittel = { hidden_input: true };
                config.kraftstoff = { hidden_input: true };
                config.entfernung = { ...config.entfernung, hidden_input: true };
                config.kosten = { hidden_input: true };
                config.personen = { hidden_input: true };
                config.energietraeger_tid = { hidden_input: true };
                config.verbrauch = { hidden_input: true };
                config.modus = { hidden_input: true };
                config.hin_rueck = { hidden_input: true };
            } else if (!item.modus || item.modus === 0 || item.modus === '0' || item.modus === 'distance_based') {
                config.kosten = { hidden_input: true };
                config.energietraeger_tid = { hidden_input: true };
                config.verbrauch = { hidden_input: true };
                config.entfernung = { ...config.entfernung, required: true };
                config.hin_rueck = { required: true };
                if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                    config.entfernung = { ...config.entfernung, readonly: true };
                    config.kraftstoff = { hidden_input: true };
                    config.personen = { required: true };
                } else {
                    config.transportmittel = { required: true };
                    config.entfernung = { ...config.entfernung, required: true };
                    if (item.transportmittel === 'bus' || item.transportmittel === 'reisebus' ||
                        item.transportmittel === 'bahn' || item.transportmittel === 'bahn_fern' ||
                        item.transportmittel === 'tram' || item.transportmittel === 'flugzeug_international' ||
                        item.transportmittel === 'flugzeug_national') {
                        config.personen = { required: true };
                    } else {
                        config.personen = { hidden_input: true };
                    }
                }
            } else if (item.modus === 'spend_based') {
                config.energietraeger_tid = { hidden_input: true };
                config.verbrauch = { hidden_input: true };
                config.entfernung = { ...config.entfernung, hidden_input: true };
                config.hin_rueck = { hidden_input: true };
                config.personen = { hidden_input: true };
                config.kraftstoff = { hidden_input: true };
                if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.kosten = { readonly: true };
                    config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                } else {
                    config.transportmittel = { required: true };
                    config.kosten = { required: true };
                }
            } else if (item.modus === 'fuel_based') {
                config.kosten = { hidden_input: true };
                config.entfernung = { ...config.entfernung, hidden_input: true };
                config.hin_rueck = { hidden_input: true };
                config.transportmittel = { hidden_input: true };
                config.kraftstoff = { hidden_input: true };
                config.verbrauch = { required: true };
                config.personen = { hidden_input: true };
                if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.verbrauch = { readonly: true, hidden_msg: 'Mehrere Verbräuche' };
                    config.energietraeger_tid = { hidden_input: true, hidden_msg: 'Mehrere Energieträger' };
                } else {
                    config.verbrauch = { required: true };
                    config.energietraeger_tid = { required: true };
                }
            } else if (item.modus === 'user_specific') {
                [
                    'teilstrecken', 'hin_rueck', 'transportmittel', 'kraftstoff', 'personen', 'entfernung', 'kosten', 'energietraeger_tid',
                    'verbrauch', 'uebernachtungen', 'reiseland', 'uebernachtungen_anzahl', 'teilnehmer', 'unterkunft'
                ].forEach((key: string) => config[key] = {
                    ...((config[key] || {}).hidden ? config[key] : { hidden_input: true })
                });
            }

            if ([0, 2].indexOf(+item.uebernachtungen_orig || +item.uebernachtungen || 0) !== -1 || item.uebernachtungen === 'Nein') {
                config.uebernachtungen_anzahl = { hidden_input: true };
                config.teilnehmer = { hidden_input: true };
                config.reiseland = { hidden_input: true };
                if (co2_fussabdruck_ghg) {
                    config.unterkunft = { hidden_input: true };
                }
            } else {
                config.reiseland = !(config.reiseland || {}).hidden_input ? { required: true } : config.reiseland || {};
                if (co2_fussabdruck_ghg) {
                    config.unterkunft = item.reiseland === 'deutschland' && !(config.unterkunft || {}).hidden_input
                        ? { required: true }
                        : { hidden_input: true };
                }
            }

            if (item.transportmittel === 'uebernachtung') {
                config.teilstrecken = { hidden_input: true };
                config.hin_rueck = { hidden_input: true, required: false };
                config.entfernung = { hidden_input: true, required: false };
                config.uebernachtungen = { readonly: true };
            }

            if (modul !== 'cfm' || !co2_fussabdruck_ghg) {
                config.name_nutzer = { hidden: true };
                config.einheit_nutzer = { hidden: true };
                config.menge_nutzer = { hidden: true };
                config.faktor_nutzer = { hidden: true };
                config.quelle_nutzer = { hidden: true };
                config.datenqualitaet_emissionsfaktor = { hidden: true };
                config.bewertung_emissionsfaktor = { hidden: true };
                config.datenqualitaet_emissionsfaktor = { hidden: true };
                config.datenherkunft = { hidden: !(modul === 'cfm') };
            } else if (item.modus !== 'user_specific' || isJa('firmenfahrzeug', item)) {
                config.name_nutzer = { hidden_input: true };
                config.einheit_nutzer = { hidden_input: true };
                config.menge_nutzer = { hidden_input: true };
                config.faktor_nutzer = { hidden_input: true };
                config.quelle_nutzer = { hidden_input: true };
                config.datenqualitaet_emissionsfaktor = { hidden_input: true };
            }
            break;
        case IDs.ENT_CO2_SCOPE3_PENDELN:
            config.arbeitstage = { placeholder: 200 };
            if (!co2_fussabdruck_ghg) {
                config.modus = { hidden: true };
                config.energietraeger_tid = { hidden: true };
                config.verbrauch = { hidden: true };
                config.kosten = { hidden: true };
                config.entfernung = { required: true };
                config.hin_rueck = { hidden: true };
                if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Transportmittel' };
                    config.kraftstoff = { hidden_input: true };
                    config.entfernung = { readonly: true };
                } else {
                    config.transportmittel = { required: true };
                    config.kraftstoff = !(item.transportmittel || '').startsWith('pkw_') 
                        ? { hidden_input: true }
                        : { required: true };
                }
                // WKETOOL-65: 346 "(Distance-based)" im  bei der "kompakten Erfassung" nicht anzeigen
                config.kraftstoff = {
                    ...(config.kraftstoff || {}),
                    label: 'Kraftstoff'
                };
            } else if (!item.modus || item.modus === 0 || item.modus === '0' || item.modus === 'distance_based') {
                config.kosten = { hidden_input: true };
                config.energietraeger_tid = { hidden_input: true };
                config.verbrauch = { hidden_input: true };
                config.entfernung = { required: true };
                config.hin_rueck = { required: true };
                if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Transportmittel' };
                    config.kraftstoff = { hidden_input: true };
                    config.entfernung = { readonly: true };
                } else {
                    config.transportmittel = { required: true };
                    config.kraftstoff = !(item.transportmittel || '').startsWith('pkw_')
                        ? { hidden_input: true }
                        : { required: true };
                }
            } else if (item.modus === 'spend_based') {
                // Hinweis: MODUS Spend-Based für Pendeln wurde entfernt
                /*
                config.energietraeger_tid = { hidden_input: true };
                config.verbrauch = { hidden_input: true };
                config.entfernung = { hidden_input: true };
                // config.teilstrecken = { hidden_input: true };
                config.kraftstoff = { hidden_input: true };
                config.kosten = { required: true };
                if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.kosten = { readonly: true };
                    config.transportmittel = { hidden_input: true, hidden_msg: 'Mehrere Lieferfahrzeuge' };
                } else {
                    config.transportmittel = { required: true };
                    config.kosten = { required: true };
                }
                */
            } else if (item.modus === 'fuel_based') {
                config.kosten = { hidden_input: true };
                config.entfernung = { hidden_input: true };
                // config.teilstrecken = { hidden_input: true };
                config.transportmittel = { hidden_input: true };
                config.kraftstoff = { hidden_input: true };
                config.verbrauch = { required: true };
                config.hin_rueck = { hidden_input: true };
                if (item.teilstrecken_orig === 1 || item.teilstrecken === 'Ja' || item.teilstrecken === 1) {
                    config.verbrauch = { readonly: true, hidden_msg: 'Mehrere Verbräuche' };
                    config.energietraeger_tid = { hidden_input: true, hidden_msg: 'Mehrere Energieträger' };
                } else {
                    config.verbrauch = { required: true };
                    config.energietraeger_tid = { required: true };
                }
            } else if (item.modus === 'user_specific') {
                [
                    'teilstrecken', 'hin_rueck', 'transportmittel', 'kraftstoff', 'entfernung', 'kosten', 'energietraeger_tid', 'verbrauch',
                    'uebernachtungen_anzahl', 'unterkunft'
                ].forEach((key: string) => config[key] = {
                    ...((config[key] || {}).hidden ? config[key] : { hidden_input: true })
                });
            }
            if (modul !== 'cfm' || !co2_fussabdruck_ghg) {
                config.name_nutzer = { hidden: true };
                config.einheit_nutzer = { hidden: true };
                config.menge_nutzer = { hidden: true };
                config.faktor_nutzer = { hidden: true };
                config.quelle_nutzer = { hidden: true };
                config.datenqualitaet_emissionsfaktor = { hidden: true };
                config.bewertung_emissionsfaktor = { hidden: true };
                config.datenherkunft = { hidden: !(modul === 'cfm') };
            } else if (item.modus !== 'user_specific') {
                config.name_nutzer = { hidden_input: true };
                config.einheit_nutzer = { hidden_input: true };
                config.menge_nutzer = { hidden_input: true };
                config.faktor_nutzer = { hidden_input: true };
                config.quelle_nutzer = { hidden_input: true };
                config.datenqualitaet_emissionsfaktor = { hidden_input: true };
            }
            break;
        case IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE: // no break
        case IDs.ENT_ANABREISE: // no break
        case IDs.ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN: // no break
        case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_RAEUMLICHKEITEN: // no break
        case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_FAHRZEUGE:
            if (modul !== 'cfm') {
                config.datenherkunft = { hidden: true };
                config.datenqualitaet_emissionsfaktor = { hidden: true };
                config.bewertung_emissionsfaktor = { hidden: true };
            }
            break;
        case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK:
            if (modul !== 'cfm') {
                config.datenherkunft = { hidden: true };
            }
            if (item.energietraeger_art === 'strom') {
                config.energietraeger_tid2 = { hidden_input: true }; // Kraftstoff
                config.energietraeger_tid = { hidden_input: true }; // Weitere Energieträger
            } else if (item.energietraeger_art === 'kraftstoffe') {
                config.energietraeger_tid = { hidden_input: true }; // Weitere Energieträger
            } else if (item.energietraeger_art === 'weitere') {
                config.energietraeger_tid2 = { hidden_input: true }; // Kraftstoff
            }
            break;
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG: // no break
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG: // no break
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS: // no break
        case IDs.ENT_CO2_SCOPE3_FRANCHISE: // no break
        case IDs.ENT_CO2_SCOPE3_INVESTITION:
            if (modul !== 'cfm') {
                config.datenherkunft = { hidden: true };
                config.datenqualitaet_emissionsfaktor = { hidden: true };
                config.bewertung_emissionsfaktor = { hidden: true };
            }
            break;
        case IDs.ENT_CO2_SCOPE3_EMITTENTEN:
            if (item.emissionsangabe === 'emissionen_absolut') {
                config.einheit = { hidden_input: true };
                config.menge = { hidden_input: true };
                config.faktor = { hidden_input: true };
            } else {
                config.co2_gesamt = { hidden_input: true };
            }
            break;
        case IDs.ENT_STANDORT:
            config.plz = {
                validMsgStyle: { marginTop: -10 }
            };
            if (+(item.standort_typ_tid_orig || +item.standort_typ_tid || null) === 1) {
                config.strasse = { readonly: false };
                config.hausnummer = { readonly: false };
                config.plz = { ...config.plz, readonly: false };
                config.standort_tid = { hidden: true };
                config.datum_von = { hidden: true };
                config.datum_bis = { hidden: true };
            } else if (+(item.standort_typ_tid_orig || +item.standort_typ_tid || null) === 5) {
                config.standort_tid = { hidden: false };
                config.strasse = { hidden: true };
                config.hausnummer = { hidden: true };
                config.ort = { hidden: true };
                config.plz = { ...config.plz, hidden: true };
                config.datum_von = { hidden: false };
                config.datum_bis = { hidden: false };
            } else if (+(item.standort_typ_tid_orig || +item.standort_typ_tid || null) === 6) {
                config.standort_tid = { hidden: true };
                config.strasse = { readonly: false };
                config.hausnummer = { readonly: false };
                config.plz = { ...config.plz, readonly: false };
                config.datum_von = { hidden: false };
                config.datum_bis = { hidden: false };
            } else {
                config.standort_tid = { hidden: true };
                config.datum_von = { hidden: true };
                config.datum_bis = { hidden: true };
                config.strasse = { readonly: false };
                config.hausnummer = { readonly: false };
                config.plz = { ...config.plz, readonly: false };
            }
            // WKETOOL-139: Feld ausblenden / Angezeigt Nur wenn die Frage in einem bis dato bestehenden Tool mit „Nein“ beantwortet wurde.
            if (item.tid === 0 || item.energiedaten_erfassen_orig === 1 || item.energiedaten_erfassen === 1) {
                config.energiedaten_erfassen = { hidden: true };
            }
            if (modul === 'cfm') {
                const untData: any[] = data[IDs.ENT_UNTERNEHMENSDATEN] || [];
                const hat_tochtergesellschaften = untData.some((d: any) => d.hat_tochtergesellschaften_orig === 1);
                config.tochtergesellschaften = { hidden: !hat_tochtergesellschaften };
            } else if (modul === 'steuer') {
                config.plz = { ...config.plz, required: false };
            }
            break;
        case IDs.ENT_BETRIEBSDATEN:
            if (modul === 'cfm') {
                config.auslastung = { hidden: true };
            } else {
                config.datenherkunft = { hidden: true };
            }
            break;
        case IDs.ENT_ENERGIEDATEN_STROM:
            if (modul === 'cfm') {
                config.spitzenlast = { hidden: true };
            } else if (modul === 'steuer') {
                config.kosten_netto = { hidden: true };
                config.co2_emissionen = { hidden: true };
                config.spitzenlast = { hidden: true };
                config.datenherkunft = { hidden: true };
                config.strom_dritte = { required: true };
                if (item.strom_dritte_orig === 1 || item.strom_dritte === 'Ja') {
                    config.weitergeleitete_strommenge_kwh = { hidden: false };
                }
                config.seperate_abrechnung_emobil_strom = {
                    required: true,
                    validMsgStyle: { marginTop: 30 },
                    label: 'Enthält der im Feld „Bezugsmenge vom Versorgungsunternehmen“ erfasste Verbrauch auch Strom für betriebliche E-Fahrzeuge, die am Straßenverkehr teilnehmen bzw. nicht ausschließlich auf dem Firmengelände fahren?'
                };
                if (item.seperate_abrechnung_emobil_strom_orig === 1 || item.seperate_abrechnung_emobil_strom === 'Ja') {
                    config.stromverbrauch_efahrzeuge = { hidden: false };
                }
            } else {
                config.datenherkunft = { hidden: true };
            }
            break;
        case IDs.ENT_ENERGIEDATEN_EIGENSTROM:
            if (modul !== 'cfm') {
                config.datenherkunft = { hidden: true };
            }
            break;
        case IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE:
            const hasFzg = +item.fahrzeug_tid > 0 || +item.fahrzeug_tid_orig > 0;
            const isEnergietraegerStrom = item.energietraeger_tid_orig === 7 /* Ladestrom */;
            config.energietraeger_tid = hasFzg ? { readonly: true } : {};
            config.laufleistung = !hasFzg ? { hidden_input: true } : {};
            config.co2_emissionen = !isEnergietraegerStrom ? { hidden_input: true } : {};
            if (modul !== 'cfm') {
                config.datenherkunft = { hidden: true };
            }
            break;
        case IDs.ENT_ENERGIEDATEN_WAERME:
            const prozesswaermeRelevant: boolean = (getWZobject(data) || {}).prozesswaerme_relevant === 1;
            config.co2_emissionen = { required: item.energietraeger_tid === 'Sonstige Wärmeträger' };
            if (modul === 'cfm') {
                if (!prozesswaermeRelevant) {
                    config.prozess_waerme = { hidden: true };
                }
            } else if (modul === 'steuer') {
                config.kosten = { hidden: true };
                config.prozess_waerme = { hidden: true };
                config.co2_emissionen = { hidden: true };
                config.datenherkunft = { hidden: true };
                config.waerme_dritte = { required: true };
                if (item.waerme_dritte_orig === 1 || item.waerme_dritte === 'Ja') {
                    config.weitergeleitete_waermemenge_kwh = { hidden: false };
                }
            } else {
                config.datenherkunft = { hidden: true };
            }
            break;
        case IDs.ENT_ENERGIEDATEN_WASSER:
            if (modul === 'cfm') {
                config.abrechnungsart = { hidden: true };
                config.einheit_regen_tid = { hidden: true };
                config.regen_brunnennutzung = { hidden: true };
                config.abwasser = {
                    hidden: false,
                    ...(typeof item.fremdbezug === 'number' && typeof item.abwasser !== 'number' && { placeholder: item.fremdbezug })
                };
                config.rueckerstattung = { hidden: true };
                config.messsystem = { hidden: true };
                config.kalibrierung = { hidden: true };
                if (typeof item.verbrauch2 === 'number' && typeof item.abwasser2 !== 'number') {
                    config.abwasser2 = { placeholder: item.verbrauch2 };
                }
                if (isNein('weitere_wasserquellen', item)) {
                    config.titel_weitere_wasserquellen = { hidden_input: true };
                    config.zaehler2_tid = { hidden_input: true };
                    config.einheit2_tid = { hidden_input: true };
                    config.verbrauch2 = { hidden_input: true };
                    config.abwasser2 = { hidden_input: true };
                    config.kosten_abwasser2 = { hidden_input: true };
                    config.datenherkunft2 = { hidden_input: true };
                }
            } else {
                config.datenherkunft = { hidden: true };
                config.titel_leitungswasser = { hidden: true };
                config.weitere_wasserquellen = { hidden: true };
                config.titel_weitere_wasserquellen = { hidden: true };
                config.zaehler2_tid = { hidden: true };
                config.einheit2_tid = { hidden: true };
                config.verbrauch2 = { hidden: true };
                config.abwasser2 = { hidden: true };
                config.kosten_abwasser2 = { hidden: true };
                config.datenherkunft2 = { hidden: true };
            }
            break;
        case IDs.ENT_KLIMAGASE:
            if (modul !== 'cfm') {
                config.datenherkunft = { hidden: true };
            }
            break;
        case IDs.ENT_ANGEMIETETE_FAHRZEUGE:
            if (modul !== 'cfm') {
                config.datenherkunft = { hidden: true };
            }
            if (item.transportmittel === 'lkw_gross') {
                config.kraftstoff = { hidden_input: true };
            }
            break;
        case IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN:
            if (item.klimatisiert_fernkaelte_orig === 1 || item.klimatisiert_fernkaelte === 'Ja' || item.klimatisiert_fernkaelte === 1) {
                config.faktor_kaelte = { required: true };
            } else {
                config.faktor_kaelte = { hidden_input: true };
            }
            break;
        case IDs.ENT_EIGENE_RAEUMLICHKEITEN:
            if (item.klimatisiert_fernkaelte_orig === 1 || item.klimatisiert_fernkaelte === 'Ja' || item.klimatisiert_fernkaelte === 1) {
                config.faktor_kaelte = { required: true };
            } else {
                config.faktor_kaelte = { hidden_input: true };
            }
            break;
        case IDs.ENT_MASCHINEN:
            config.abwaerme = { required: (data[IDs.ENT_KONFIGURATION] || []).some((param: any) => param.alternatives_system_orig === 1) };
            config.standort_tid = { readonly: !!item.standort_tid };
            break;
        case IDs.ENT_OEL_ABRECHNUNG:
            config.datum_befuellung = { autofill: false };
            config.datum_rechnung = { autofill: false };
            if (disableKosten(data)) {
                config.kosten = { hidden: true };
            }
            break;
        case IDs.ENT_FAHRZEUGE:
            config.standort_tid = { readonly: !!item.standort_tid };
            break;
        case IDs.ENT_UNTERNEHMENSDATEN:
            config.wz_tid = {
                validMsgStyle: { marginTop: -75 },
                showFullValidMsg: true
            };
            config.plz = {
                validMsgStyle: { marginTop: -10 }
            };
            if (
                (item.bereich_key_orig || item.bereich_key) === 'privat'
                || [147].indexOf(+(item.gewerk_tid_orig || item.gewerk_tid)) !== -1
            ) {
                config.wz_tid = { ...config.wz_tid, hidden: true, required: false };
            }
            if (modul === 'cfm') {
                config.rechtsform = { hidden: false };
                config.hat_tochtergesellschaften = { hidden: false };
                config.tochtergesellschaften = { hidden: item.hat_tochtergesellschaften_orig !== 1 };
            } else if (modul === 'steuer') {
                config.wz_tid = { ...config.wz_tid, sysTxtKeyHinweis: 'hinweis_unternehmen_wz_tid' };
                config.plz = { ...config.plz, required: false };
            }
            break;
    }

    if (Object.keys(components).length) {
        Object.keys(components).forEach((key: string) => config[key] = { ...(config[key] || {}), ...components[key] });
    }

    if (Object.keys(events).length) {
        Object.keys(events).forEach((key: string) => config[key] = { ...(config[key] || {}), ...events[key] });
    }

    return config;
}

export function isConfigVorsteuerNetto(data: any): any {
    const isVorsteuerNetto = +((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).vorsteuerabzugsberechtigt_orig === 1; // 1 = netto, 2 = brutto
    return isVorsteuerNetto;
}

export function getCustomFormConfigVorsteuer(entity: string, item: any, data: any, config: any): any {
    const vorsteuer_netto = isConfigVorsteuerNetto(data);
    if (!vorsteuer_netto) {
        if (StructureService.structures && StructureService.structures[IDs.MOD_ETOOL] && StructureService.structures[IDs.MOD_ETOOL][entity]) {
            const struc = StructureService.structures[IDs.MOD_ETOOL][entity];
            (struc.ATTS || [])
                .filter((i: any) => i.FORMAT === "EURO" && i.KEY.indexOf('kosten') !== -1 && i.NAME.indexOf('netto') !== -1)
                .forEach((i: any) => {
                    if (!config[i.KEY]) {
                        config[i.KEY] = {};
                    }
                    config[i.KEY].label = i.NAME.replace('netto', 'brutto');
                });
        }
        // console.log(entity, config);
    }
    return config;
}

export function getCustomFormConfigNutzerEinheit(entity: string, item: any, config: any): any {
    if (item.modus === 'user_specific' && item.einheit_nutzer) {
        if (StructureService.structures && StructureService.structures[IDs.MOD_ETOOL] && StructureService.structures[IDs.MOD_ETOOL][entity]) {
            const struc = StructureService.structures[IDs.MOD_ETOOL][entity];
            (struc.ATTS || [])
                .filter((i: any) => i.KEY === 'faktor_nutzer' || i.NAME === 'Emissionsfaktor lt. Datenbank / Einheit')
                .forEach((i: any) => {
                    if (!config[i.KEY]) {
                        config[i.KEY] = {};
                    }
                    config[i.KEY].label = `Emissionsfaktor lt. Datenbank / ${item.einheit_nutzer}`;
                });
        }
        // console.log(entity, item, config);
    }
    return config;
}

function isJa(key: string, data: any): boolean {
    return (+data[`${key}_orig`] || +data[key]) === 1 || data[key] === 'Ja';
}

function isNein(key: string, data: any): boolean {
    return [0, 2].indexOf(+data[`${key}_orig`] || +data[key] || 0) !== -1 || data[key] === 'Nein';
}
